export default __webpack_public_path__ + "static/media/BalooChettan2-ExtraBold.10dc86f7.ttf";